import { __assign } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import { KpkFilterModifierType } from '@keepeek/commons';
import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import clsx from 'clsx';
import cloneDeep from 'lodash/cloneDeep';
import { useTranslation } from 'react-i18next';
import FieldTags from '../../Fields/FieldTags/index.js';
import StyledFilterTags, { classes } from './index.styled.js';

function getAllowedOptionsValues() {
    return [
        KpkFilterModifierType.EqualsNoValues,
        KpkFilterModifierType.Empty,
        KpkFilterModifierType.EqualsOne,
        KpkFilterModifierType.Equals,
    ];
}
var FilterTags = function (_a) {
    var _b, _c;
    var className = _a.className, filter = _a.filter, onFilterUpdate = _a.onFilterUpdate, expandIcon = _a.expandIcon, expanded = _a.expanded, setExpanded = _a.setExpanded, sx = _a.sx, tags = _a.tags, KIcon = _a.KIcon;
    var t = useTranslation("refront-components").t;
    var initialSelectedModifier = ((_c = (_b = filter === null || filter === void 0 ? void 0 : filter.modifiers) === null || _b === void 0 ? void 0 : _b.find(function (m) { return m.selected; })) === null || _c === void 0 ? void 0 : _c.type) || KpkFilterModifierType.EqualsOne;
    var _d = useState(initialSelectedModifier), currentOption = _d[0], setCurrentOption = _d[1];
    // Need to use useEffect here to change state if derived prop state change :
    // https://reacthustle.com/blog/how-to-update-state-when-props-change-in-react
    useEffect(function () { return setCurrentOption(initialSelectedModifier); }, [initialSelectedModifier]);
    var handleOptionChange = function (value) {
        var _a;
        if (value) {
            setCurrentOption(value);
            onFilterUpdate(__assign(__assign({}, filter), { modifiers: ((_a = filter === null || filter === void 0 ? void 0 : filter.modifiers) === null || _a === void 0 ? void 0 : _a.map(function (m) {
                    return __assign(__assign({}, m), { selected: value === m.type ? true : null });
                })) || [], values: [] }));
        }
    };
    var handleTagChange = function (updatedTag) {
        var _a;
        var clonedFilter = cloneDeep(filter);
        if (updatedTag.enabled) {
            clonedFilter.values.push({
                id: updatedTag.tagId,
                label: ((_a = tags.find(function (t) { return t.id === updatedTag.tagId; })) === null || _a === void 0 ? void 0 : _a.name) || "",
                selected: true
            });
        }
        else {
            clonedFilter.values = clonedFilter.values.filter(function (v) { return v.id !== updatedTag.tagId; });
        }
        onFilterUpdate(__assign(__assign({}, clonedFilter), { modifiers: [
                {
                    type: currentOption,
                    selected: true
                },
            ] }));
    };
    var enabledTagIdValues = filter.values.filter(function (v) { return v.selected; }).map(function (v) { return v.id; });
    return (React__default.createElement(StyledFilterTags, { className: clsx("FilterTags", className), filter: filter, expanded: expanded, setExpanded: setExpanded, expandIcon: expandIcon, testId: "FilterTags", sx: sx },
        React__default.createElement(Grid, { container: true, justifyContent: "space-around" },
            React__default.createElement(FormControl, { className: classes.selectFormControl, fullWidth: true, size: "small", variant: "outlined" },
                React__default.createElement(InputLabel, { id: "FilterTags-".concat(filter.type, "-").concat(filter.id) }, t("components.filter-tags.input-select.label")),
                React__default.createElement(Select, { onChange: function (_a) {
                        var target = _a.target;
                        return handleOptionChange(target.value);
                    }, id: "FilterTags-".concat(filter.type, "-").concat(filter.id), labelId: "FilterTags-".concat(filter.type, "-").concat(filter.id), label: t("components.filter-tags.input-select.label"), value: currentOption }, getAllowedOptionsValues().map(function (val) { return (React__default.createElement(MenuItem, { key: val, value: val, sx: {
                        padding: function (theme) { return theme.spacing(0, 1, 0, 1); },
                        fontSize: "0.875rem",
                        minHeight: "0px"
                    } }, t("components.filter-tags.option.".concat(val, ".label")))); }))),
            currentOption !== KpkFilterModifierType.Empty && (React__default.createElement(FieldTags, { tags: tags, onChange: handleTagChange, enabledTagIdValues: enabledTagIdValues, sx: {
                    width: "100%"
                }, KIcon: KIcon })))));
};

export { FilterTags as default, getAllowedOptionsValues };
//# sourceMappingURL=index.js.map
